module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "conferecing-and-vunue-hire"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1) : _vm._l((_vm.tabs), function(tab, index) {
    return _c('div', {
      key: index
    }, [(tab.section_1) ? _c('sk-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('sk-flex', {
      attrs: {
        "xs12": "",
        "sm7": ""
      }
    }, [(tab.section_1.heading) ? _c('h3', [_vm._v(_vm._s(tab.section_1.heading))]) : _vm._e(), _vm._v(" "), _c('p', {
      domProps: {
        "innerHTML": _vm._s(tab.section_1.body)
      }
    }), _vm._v(" "), (tab.section_1.button_link) ? _c('sk-button', {
      staticStyle: {
        "display": "inline-block"
      },
      attrs: {
        "primary": "",
        "tag": "a",
        "href": tab.section_1.button_link
      }
    }, [_vm._v(_vm._s(tab.section_1.button_text))]) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (tab.section_2) ? _c('hr') : _vm._e(), _vm._v(" "), (tab.section_2) ? _c('sk-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('sk-flex', {
      attrs: {
        "xs12": "",
        "sm7": ""
      }
    }, [(tab.section_2.heading) ? _c('h3', [_vm._v(_vm._s(tab.section_2.heading))]) : _vm._e(), _vm._v(" "), _c('p', {
      domProps: {
        "innerHTML": _vm._s(tab.section_2.body)
      }
    }), _vm._v(" "), (tab.section_2.button_link) ? _c('sk-button', {
      staticStyle: {
        "display": "inline-block"
      },
      attrs: {
        "primary": "",
        "tag": "a",
        "href": tab.section_2.button_link
      }
    }, [_vm._v(_vm._s(tab.section_2.button_text))]) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (tab.section_3) ? _c('hr') : _vm._e(), _vm._v(" "), (tab.section_3) ? _c('sk-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('sk-flex', {
      attrs: {
        "xs12": "",
        "sm7": ""
      }
    }, [(tab.section_3.heading) ? _c('h3', [_vm._v(_vm._s(tab.section_3.heading))]) : _vm._e(), _vm._v(" "), _c('p', {
      domProps: {
        "innerHTML": _vm._s(tab.section_3.body)
      }
    }), _vm._v(" "), (tab.section_3.button_link) ? _c('sk-button', {
      staticStyle: {
        "display": "inline-block"
      },
      attrs: {
        "primary": "",
        "tag": "a",
        "href": tab.section_3.button_link
      }
    }, [_vm._v(_vm._s(tab.section_3.button_text))]) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (tab.section_4) ? _c('hr') : _vm._e(), _vm._v(" "), (tab.section_4) ? _c('sk-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('sk-flex', {
      attrs: {
        "xs12": "",
        "sm7": ""
      }
    }, [(tab.section_4.heading) ? _c('h3', [_vm._v(_vm._s(tab.section_4.heading))]) : _vm._e(), _vm._v(" "), _c('p', {
      domProps: {
        "innerHTML": _vm._s(tab.section_4.body)
      }
    }), _vm._v(" "), (tab.section_4.button_link) ? _c('sk-button', {
      staticStyle: {
        "display": "inline-block"
      },
      attrs: {
        "primary": "",
        "tag": "a",
        "href": tab.section_4.button_link
      }
    }, [_vm._v(_vm._s(tab.section_4.button_text))]) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (tab.section_5) ? _c('hr') : _vm._e(), _vm._v(" "), (tab.section_5) ? _c('sk-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('sk-flex', {
      attrs: {
        "xs12": "",
        "sm7": ""
      }
    }, [(tab.section_5.heading) ? _c('h3', [_vm._v(_vm._s(tab.section_5.heading))]) : _vm._e(), _vm._v(" "), _c('p', {
      domProps: {
        "innerHTML": _vm._s(tab.section_5.body)
      }
    }), _vm._v(" "), (tab.section_5.button_link) ? _c('sk-button', {
      staticStyle: {
        "display": "inline-block"
      },
      attrs: {
        "primary": "",
        "tag": "a",
        "href": tab.section_5.button_link
      }
    }, [_vm._v(_vm._s(tab.section_5.button_text))]) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (tab.section_6) ? _c('hr') : _vm._e(), _vm._v(" "), (tab.section_6) ? _c('sk-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('sk-flex', {
      attrs: {
        "xs12": "",
        "sm7": ""
      }
    }, [(tab.section_6.heading) ? _c('h3', [_vm._v(_vm._s(tab.section_6.heading))]) : _vm._e(), _vm._v(" "), _c('p', {
      domProps: {
        "innerHTML": _vm._s(tab.section_6.body)
      }
    }), _vm._v(" "), (tab.section_6.button_link) ? _c('sk-button', {
      staticStyle: {
        "display": "inline-block"
      },
      attrs: {
        "primary": "",
        "tag": "a",
        "href": tab.section_6.button_link
      }
    }, [_vm._v(_vm._s(tab.section_6.button_text))]) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (tab.section_7) ? _c('hr') : _vm._e(), _vm._v(" "), (tab.section_7) ? _c('sk-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('sk-flex', {
      attrs: {
        "xs12": "",
        "sm7": ""
      }
    }, [(tab.section_7.heading) ? _c('h3', [_vm._v(_vm._s(tab.section_7.heading))]) : _vm._e(), _vm._v(" "), _c('p', {
      domProps: {
        "innerHTML": _vm._s(tab.section_7.body)
      }
    }), _vm._v(" "), (tab.section_7.button_link) ? _c('sk-button', {
      staticStyle: {
        "display": "inline-block"
      },
      attrs: {
        "primary": "",
        "tag": "a",
        "href": tab.section_7.button_link
      }
    }, [_vm._v(_vm._s(tab.section_7.button_text))]) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (tab.section_8) ? _c('hr') : _vm._e(), _vm._v(" "), (tab.section_8) ? _c('sk-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('sk-flex', {
      attrs: {
        "xs12": "",
        "sm7": ""
      }
    }, [(tab.section_8.heading) ? _c('h3', [_vm._v(_vm._s(tab.section_8.heading))]) : _vm._e(), _vm._v(" "), _c('p', {
      domProps: {
        "innerHTML": _vm._s(tab.section_8.body)
      }
    }), _vm._v(" "), (tab.section_8.button_link) ? _c('sk-button', {
      staticStyle: {
        "display": "inline-block"
      },
      attrs: {
        "primary": "",
        "tag": "a",
        "href": tab.section_8.button_link
      }
    }, [_vm._v(_vm._s(tab.section_8.button_text))]) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (tab.section_9) ? _c('hr') : _vm._e(), _vm._v(" "), (tab.section_9) ? _c('sk-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('sk-flex', {
      attrs: {
        "xs12": "",
        "sm7": ""
      }
    }, [(tab.section_9.heading) ? _c('h3', [_vm._v(_vm._s(tab.section_9.heading))]) : _vm._e(), _vm._v(" "), _c('p', {
      domProps: {
        "innerHTML": _vm._s(tab.section_9.body)
      }
    }), _vm._v(" "), (tab.section_9.button_link) ? _c('sk-button', {
      staticStyle: {
        "display": "inline-block"
      },
      attrs: {
        "primary": "",
        "tag": "a",
        "href": tab.section_9.button_link
      }
    }, [_vm._v(_vm._s(tab.section_9.button_text))]) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (tab.section_10) ? _c('hr') : _vm._e(), _vm._v(" "), (tab.section_10) ? _c('sk-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('sk-flex', {
      attrs: {
        "xs12": "",
        "sm7": ""
      }
    }, [(tab.section_10.heading) ? _c('h3', [_vm._v(_vm._s(tab.section_10.heading))]) : _vm._e(), _vm._v(" "), _c('p', {
      domProps: {
        "innerHTML": _vm._s(tab.section_10.body)
      }
    }), _vm._v(" "), (tab.section_10.button_link) ? _c('sk-button', {
      staticStyle: {
        "display": "inline-block"
      },
      attrs: {
        "primary": "",
        "tag": "a",
        "href": tab.section_10.button_link
      }
    }, [_vm._v(_vm._s(tab.section_10.button_text))]) : _vm._e()], 1)], 1) : _vm._e()], 1)
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ca1e3d0","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sales-at-sk/conferencing-and-venue-hire/conferencing-and-venue-hire.vue
// module id = 836
// module chunks = 0